'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardEmbeddedVideo = require('../ContentCardEmbeddedVideo');

var _ContentCardEmbeddedVideo2 = _interopRequireDefault(_ContentCardEmbeddedVideo);

var _ContentCardHeader = require('../ContentCardHeader');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

var _TwitterDetails = require('../TwitterDetails/TwitterDetails');

var _TwitterDetails2 = _interopRequireDefault(_TwitterDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterVideoStreamContentCard = function TwitterVideoStreamContentCard(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ContentCardHeader2.default, { isLarge: props.isLarge, iconType: 'twitter' }),
    _react2.default.createElement(_ContentCardEmbeddedVideo2.default, {
      src: 'https://twitter.com/i/videos/' + props.videoID,
      title: props.text,
      modalEnabled: props.modalEnabled
    }),
    _react2.default.createElement(_TwitterDetails2.default, {
      isLarge: props.isLarge,
      authorHandle: props.authorHandle,
      authorName: props.authorName,
      url: props.url,
      verified: props.verified,
      profileUrl: props.profileUrl,
      profileImageUrl: props.profileImageUrl
    }),
    _react2.default.createElement(_ContentCardText2.default, {
      caption: props.caption,
      text: props.text,
      isLarge: props.isLarge
    }),
    props.messengerShareButton
  );
};

TwitterVideoStreamContentCard.propTypes = {
  authorHandle: _propTypes2.default.string.isRequired,
  authorName: _propTypes2.default.string.isRequired,
  messengerShareButton: _propTypes2.default.node,
  profileUrl: _propTypes2.default.string.isRequired,
  profileImageUrl: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired,
  verified: _propTypes2.default.bool.isRequired,
  videoID: _propTypes2.default.string.isRequired,
  caption: _propTypes2.default.string,
  modalEnabled: _propTypes2.default.bool,
  isLarge: _propTypes2.default.bool
};

TwitterVideoStreamContentCard.defaultProps = {
  messengerShareButton: null,
  caption: '',
  modalEnabled: false,
  isLarge: false
};

TwitterVideoStreamContentCard.displayName = 'TwitterVideoStreamContentCard';

exports.default = (0, _withContentCardFooter2.default)(TwitterVideoStreamContentCard);